<div [class]="hostClasses.join(' ')">
  <mat-icon class="material-symbols-rounded munily-alert__icon" aria-hidden="true">{{ iconLigature }}</mat-icon>

  <div class="munily-alert__labels">
    <p
      *ngIf="!richText"
      class="munily-alert__emphasis"
    >{{ emphasisText }}</p>
    <p
      *ngIf="richText"
      class="munily-alert__emphasis munily-alert__rich"
      [innerHTML]="emphasisText | safeHtml"
    ></p>
    <p
      *ngIf="showDescription && !richText"
      class="munily-alert__description"
    >{{ description }}</p>
    <p
      *ngIf="showDescription && richText"
      class="munily-alert__description munily-alert__rich"
      [innerHTML]="description | safeHtml"
    ></p>
  </div>
</div>
